import React, { useEffect, useState } from 'react';
import { useLanguage } from '../../../helpers/language-context';
import { supabase } from '../../../supabaseClient';

const BoardMember = () => {
  const { translations } = useLanguage();
  const [boardMember, setBoardMember] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBoardMembers = async () => {
      const { data, error } = await supabase
        .from('board_members')
        .select('*')
        .order('sort_order', { ascending: true });

      if (error) {
        console.error('Error fetching board members:', error);
      } else {
        setBoardMember(data);
      }
      setLoading(false);
    };

    fetchBoardMembers();
  }, []);

  if (loading) {
    return <div className="text-white">Loading board members...</div>;
  }

  return (
    <section className="bg-[#28357B] text-white py-12">
      <div>
        <div className="flex items-center justify-between mb-12">
          <h2 className="text-4xl md:text-5xl lg:text-6xl text-white">{translations.about.theBoard}</h2>
        </div>

        {/* Board Members Layout */}
        <div className="flex flex-col items-center gap-12">

          {(() => {
            const mainMember = boardMember[0];
            const otherMembers = boardMember.slice(1);

            return (
              <>
                {/* Top Level: Chairman */}
                {mainMember && (
                  <div className="w-full max-w-sm text-center group">
                    <div className="aspect-w-1 aspect-h-1 mb-6">
                      <img
                        src={mainMember.image ?? '/assets/images/placeholder-avatar.jpg'}
                        alt={mainMember.name}
                        className="w-full aspect-square object-cover object-top rounded-xl border-2 border-transparent group-hover:border-[#FDA729] transition-all duration-300 mx-auto"
                        onError={(e) => {
                          e.target.src = '/assets/images/placeholder-avatar.jpg';
                        }}
                      />
                    </div>
                    <h3 className="text-2xl font-semibold text-white group-hover:text-[#FDA729] transition-colors duration-300">
                      {mainMember.name}
                    </h3>
                    <p className="text-lg text-white mt-2">{translations.about.board[mainMember.role] || mainMember.role}</p>
                  </div>
                )}

                {/* Grid Level: Other Members */}
                {otherMembers.length > 0 && (
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 w-full">
                    {otherMembers.map((member) => (
                      <div key={member.id} className="text-center group">
                        <div className="aspect-w-1 aspect-h-1 mb-4">
                          <img
                            src={member.image ?? '/assets/images/placeholder-avatar.jpg'}
                            alt={member.name}
                            className="w-full aspect-square object-cover object-top rounded-xl border-2 border-transparent group-hover:border-[#FDA729] transition-all duration-300 mx-auto"
                            onError={(e) => {
                              e.target.src = '/assets/images/placeholder-avatar.jpg';
                            }}
                          />
                        </div>
                        <h3 className="text-lg font-semibold text-white group-hover:text-[#FDA729] transition-colors duration-300">
                          {member.name}
                        </h3>
                        <p className="text-sm text-white mt-1">{translations.about.board[member.role] || member.role}</p>
                      </div>
                    ))}
                  </div>
                )}
              </>
            );
          })()}
        </div>
      </div>
    </section>
  );
}

export default BoardMember;
